module.exports = __webpack_public_path__ + "img/app_store.69d7c032.png";